import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { AlertCircle, X } from 'lucide-react'

interface ValidationError {
  field: string
  message: string
}

interface ValidationErrorDialogProps {
  isOpen: boolean
  onClose: () => void
  title: string
  errors: ValidationError[]
}

export function ValidationErrorDialog({ 
  isOpen, 
  onClose, 
  title, 
  errors 
}: ValidationErrorDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
              <AlertCircle className="w-5 h-5 text-red-600" />
            </div>
            <div className="flex-1">
              <AlertDialogTitle className="text-lg">{title}</AlertDialogTitle>
              <AlertDialogDescription className="mt-2">
                Please fix the following issues to continue:
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>
        
        <div className="my-4 space-y-3">
          {errors.map((error, index) => (
            <div key={index} className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded-lg">
              <X className="w-4 h-4 text-red-600 flex-shrink-0 mt-0.5" />
              <div className="flex-1">
                <div className="font-medium text-sm text-red-900">{error.field}</div>
                <div className="text-sm text-red-700 mt-0.5">{error.message}</div>
              </div>
            </div>
          ))}
        </div>
        
        <AlertDialogFooter>
          <AlertDialogAction 
            onClick={onClose}
            className="bg-primary hover:bg-primary/90"
          >
            Got it, I'll fix these
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

